import React from 'react';
import HabboImage from './HabboImage';

const NOTE_STYLES = {
    note: {
        label: 'Note',
        bg: '#FFF6B8',
        border: '#E0D07A',
        title: '#3A2E00',
        text: '#2B2B2B',
    },
    opinion: {
        label: 'User Opinions',
        bg: '#84a19a',
        border: '#66807a',
        title: '#152622',
        text: '#152622',
    },
    discord: {
        label: 'Discord Details',
        bg: '#E9ECFF',
        border: '#7289DA',
        title: '#2E3A67',
        text: '#2B2B2B',
    },
    xtra: {
        label: "X'tra Information",
        bg: '#FFFFFF',
        border: '#D9D9D9',
        title: '#111111',
        text: '#2B2B2B',
    },
    important: {
        label: 'Important!',
        bg: '#F9C4C4',
        border: '#E08C8C',
        title: '#6A0F0F',
        text: '#2B2B2B',
    },
};

function getTweetIdFromUrl(url) {
    if (!url) return null;
    const str = String(url);

    const match = str.match(/\/status\/(\d+)/i);
    if (match && match[1]) return match[1];

    const maybeId = str.trim();
    if (/^\d{10,25}$/.test(maybeId)) return maybeId;

    return null;
}

function OpinionItem({ user, text }) {
    const name = user?.name || 'User';

    return (
        <div className="flex items-start gap-3 bg-white/40 rounded px-3 py-2">
            <span className="w-[42px] h-[42px] overflow-hidden inline-block relative bg-maroon rounded-full border border-black/10 flex-shrink-0">
                <HabboImage
                    habbo={name}
                    hotel="COM"
                    size="a"
                    direction={2}
                    head_direction={3}
                    className="absolute top-[-10px] left-[5px] block max-w-none"
                />
            </span>

            <div className="min-w-0">
                <div className="text-sm font-bold text-black/80">
                    {name}
                </div>

                <div className="text-sm leading-relaxed text-black/80 mt-1">
                    {text}
                </div>
            </div>
        </div>
    );
}

function ArticleNote({
                         type = 'note',
                         title = null,
                         meta = '',
                         children = null,
                         imageSrc = null,
                         imageAlt = '',
                         xUrl = null,

                         // opinions
                         opinionsFor = [],
                         opinionsAgainst = [],
                     }) {
    const s = NOTE_STYLES[type] || NOTE_STYLES.note;
    const shownTitle = title || s.label;

    const tweetId = type === 'xtra' ? getTweetIdFromUrl(xUrl) : null;
    const xEmbedSrc = tweetId ? `https://platform.twitter.com/embed/Tweet.html?id=${tweetId}` : null;

    return (
        <div
            className="w-full rounded px-4 py-3"
            style={{
                backgroundColor: s.bg,
                border: `1px solid ${s.border}`,
            }}
        >
            <div
                className="flex items-end justify-between gap-3 pb-2 mb-3 border-b"
                style={{ borderColor: s.border }}
            >
                <div
                    className="font-bold uppercase tracking-wide text-[14px]"
                    style={{ color: s.title }}
                >
                    {shownTitle}
                </div>

                <div
                    className="text-[11px] uppercase tracking-wide text-right opacity-80"
                    style={{ color: s.text }}
                >
                    {meta}
                </div>
            </div>

            {type === 'opinion' ? (
                <div className="grid grid-cols-[1fr_auto_1fr] gap-4">
                    <div className="min-w-0">
                        <div className="text-[12px] uppercase tracking-wide font-bold mb-2" style={{ color: s.title }}>
                            For
                        </div>
                        <div className="space-y-3">
                            {opinionsFor.map((o, i) => (
                                <OpinionItem key={`for-${i}`} user={o.user} text={o.text} />
                            ))}
                        </div>
                    </div>

                    <div
                        className="w-[1px]"
                        style={{ backgroundColor: s.title }}
                    />

                    <div className="min-w-0">
                        <div className="text-[12px] uppercase tracking-wide font-bold mb-2" style={{ color: s.title }}>
                            Against
                        </div>
                        <div className="space-y-3">
                            {opinionsAgainst.map((o, i) => (
                                <OpinionItem key={`against-${i}`} user={o.user} text={o.text} />
                            ))}
                        </div>
                    </div>
                </div>

            ) : (
                <>
                    {children && (
                        <div className="text-sm leading-relaxed mb-3" style={{ color: s.text }}>
                            {children}
                        </div>
                    )}

                    {type === 'xtra' && xEmbedSrc ? (
                        <div className="w-full overflow-x-hidden overflow-y-auto max-h-[520px] bg-white rounded">
                            <iframe
                                title="X Embed"
                                src={xEmbedSrc}
                                className="w-full border-0"
                                style={{ height: 300 }}
                                loading="lazy"
                            />
                        </div>
                    ) : imageSrc ? (
                        <div className="w-full overflow-x-hidden overflow-y-auto max-h-[360px]">
                            <img
                                src={imageSrc}
                                alt={imageAlt}
                                className="block max-w-none"
                            />
                        </div>
                    ) : null}
                </>
            )}

        </div>
    );
}

export default ArticleNote;
